import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';
import { useHistory } from 'react-router-dom';

import { downloadExcelWorkReports } from '../../../services/workReport';
import useToast from '../../../hooks/useToast';
import { useFilterContext } from '../../../context/FilterContext';
import { bulidFilterWorkReportRequest } from '../../../page/ServiceRequest/FilterServiceRequest/utils/filterServiceRequestUtils';
import { ReactComponent as ExtendedViewIcon } from '../../../assets/images/extended-view-icon.svg';
import './ApprovalHeaderButtons.scss';

const ApprovalHeaderButtons = ({
  handleOrderByUbication,
  isEmpty,
  isOrderByUbication,
  selectedDate,
  pageNumber,
  isPending,
  pageSize
}) => {
  const [date] = selectedDate?.split('T') ?? '';
  const { filter } = useFilterContext();
  const { setNewToast } = useToast();

  const handleOnClickDownloadWorkReports = async () => {
    try {
      const configWorkReport = {
        pageNumber: pageNumber + 1,
        pageSize,
        agrupaPorUbicacion: isOrderByUbication
      };

      const { filters } = bulidFilterWorkReportRequest({
        filters: filter,
        paginationData: configWorkReport
      });

      await downloadExcelWorkReports({
        date,
        isPending,
        filters
      });
      setNewToast({
        type: 'SUCCESS',
        message: 'Se ha descargado el archivo correctamente'
      });
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const history = useHistory();

  return (
    <div className="d-flex justify-content-between flex-wrap gap-2">
      {!isEmpty && (
        <div className="d-flex">
          <Button
            className="m-0"
            fontSizeLabel="16px"
            label="Ordenar por ubicación"
            onClick={() => handleOrderByUbication(true)}
            type="button"
            variant={isOrderByUbication ? 'primary' : 'outline-primary'}
            widthButton="200px"
          />

          <Button
            className="mx-2"
            fontSizeLabel="16px"
            label="Ordenar por proveedor"
            onClick={() => handleOrderByUbication(false)}
            type="button"
            variant={!isOrderByUbication ? 'primary' : 'outline-primary'}
            widthButton="200px"
          />
        </div>
      )}
      <div className="d-flex">
        <Button
          className="extended-view-btn"
          fontSizeLabel="16px"
          icon={ExtendedViewIcon}
          iconRight
          label="Vista extendida"
          onClick={() => history.push(`approver/weekly-work-report/${date}`)}
          type="button"
          variant="outline-primary"
          widthButton="200px"
        />
        {!isEmpty && (
          <Button
            className="mx-2"
            fontSizeLabel="16px"
            label="Descargar xlsx"
            onClick={() => {
              handleOnClickDownloadWorkReports();
            }}
            type="button"
            variant="outline-primary"
            widthButton="200px"
          />
        )}
      </div>
    </div>
  );
};

ApprovalHeaderButtons.propTypes = {
  handleOrderByUbication: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool.isRequired,
  isOrderByUbication: PropTypes.bool.isRequired,
  selectedDate: PropTypes.string.isRequired,
  pageNumber: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  isPending: PropTypes.bool.isRequired
};

export default ApprovalHeaderButtons;
